module.exports = __webpack_public_path__ + "static/media/check-with-blue-circle.523b8b58.svg";